<template>
  <div>
    <div v-if="!loadPage && loadData">
      <luma-datatable :model="vserverNetworks"
                      :url="urlC"
                      :columns="columns">
      </luma-datatable>
    </div>
  </div>
</template>

<script>
    import {VserverNetworks} from "@/store/models/vserver/vserver_networks";
    import axios from "@/store/vue-axios"
    import LumaDatatable from "@/components/LumaDatatable";
    export default {
        name: "luma-network-vserver",
        components: {LumaDatatable},
        props:{loadPage:Boolean},
        data:()=>({
            vserverNetworks: VserverNetworks,
            loadData:true
        }),
        computed:{

            columns(){
                if(this.loadPage === true) {
                    this.getNetworks()
                }
                const x = new VserverNetworks
                delete x.$id
                return Object.keys(x).map(el=>({
                    key:el,
                    column:el,
                    filter:true,
                    order:true
                }))
            },
            vid(){
                return this.$route.params.id
            },
            urlC(){
                return "/datacenter/vservers/"+this.vid+"/networks"
            }
        },
        methods:{
            async getNetworks(){
                const x = await axios.get(this.urlC)
                    .then(response=>{
                        VserverNetworks.insertOrUpdate({data:response.data.networks})
                    })
                    .catch(error=>{
                        console.log(error)
                    })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datacenter/vserver_datacenter/luma-network-vserver.vue